if (!customElements.get('sande-gallery-controls')) {
  customElements.define('sande-gallery-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.gallery = this.closest('media-gallery');
      this.thumbnails = this.gallery.querySelector('thumbnail-slider');
      if (!this.thumbnails) return;
      this.previous = this.querySelector('[data-gallery-previous]');
      this.next = this.querySelector('[data-gallery-next]');
      const update = () => {
        this.items = [...this.thumbnails.querySelectorAll('[data-target]')].filter(item => item.getClientRects().length);
        this.index = Math.max(0, this.items.findIndex(item => item.querySelector('[aria-current="true"]')));
        this.hidden = this.items.length < 2;
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index >= this.items.length - 1;
      };
      const move = direction => {
        update();
        const item = this.items[this.index + direction];
        if (item) this.gallery.setActiveMedia(item.dataset.target, false, false);
      };
      this.previous.addEventListener('click', () => move(-1), { signal: this.controller.signal });
      this.next.addEventListener('click', () => move(1), { signal: this.controller.signal });
      this.observer = new MutationObserver(update);
      this.observer.observe(this.thumbnails, { subtree: true, attributes: true, attributeFilter: ['aria-current', 'class'] });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.thumbnails);
      update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
